import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { money, productThumb } from "../../lib/api";
import { finishLabel } from "./weddingGroups";

export function WeddingProductCard({ product }) {
  const finish = finishLabel(product.name);
  const desc = (product.short_description || product.description || "").replace(/\s+/g, " ").trim();
  return (
    <Link
      to={`/shop/product/${product.slug}`}
      className="group bg-white border border-[#E8D9C3] hover:border-[#2C3340] transition-colors flex flex-col overflow-hidden"
      data-testid={`wedding-card-${product.slug}`}
    >
      <div className="relative aspect-square overflow-hidden bg-[#F7F1E8]">
        <img
          src={productThumb(product.image_url, 700)}
          alt={`${product.name} — ${finish.toLowerCase()} wedding stationery printed by Kolt Printing`}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
          loading="lazy"
          width="700"
          height="700"
        />
        <span className="absolute top-3 left-3 font-mono text-[10px] tracking-[0.2em] uppercase font-bold bg-white/90 backdrop-blur text-[#2C3340] px-2.5 py-1" data-testid={`wedding-finish-${product.slug}`}>
          {finish}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display font-black text-lg leading-tight text-[#2C3340] group-hover:text-kolt-orange transition-colors">
          {product.name}
        </h3>
        {desc && <p className="text-sm text-slate-600 mt-2 leading-relaxed line-clamp-2">{desc}</p>}
        <div className="mt-auto pt-4 flex items-end justify-between">
          <div>
            <div className="font-mono text-[9px] tracking-[0.22em] uppercase text-slate-500">From</div>
            <div className="font-display font-black text-xl text-[#2C3340]">
              {money(product.base_price)} <span className="font-mono text-[10px] font-normal text-slate-500">/ unit</span>
            </div>
          </div>
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase font-bold text-kolt-orange inline-flex items-center gap-1">
            Configure <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </span>
        </div>
      </div>
    </Link>
  );
}
